<script setup>
import { occupationList } from '@/client'
import { client } from '@/lohnrechner'
import { useLohndatenStore } from '@/stores/lohndaten'
import { useTextStore } from '@/stores/texts'
import { nextTick } from 'vue'
import { watch } from 'vue'
import { inject, ref } from 'vue'

const store = useLohndatenStore()
const emits = defineEmits(['complete'])

const t = inject('t')

async function searchBeruf(query) {
  let pk = query ? null : store.beruf ? store.beruf : null
  return new Promise((resolve) => {
    occupationList({ client: client, query: { search: query, pk: pk } }).then((list) => {
      resolve(list.data.results.map((m) => ({ value: m.pk, label: m.name })))
    })
  })
}

function onClear() {
  store.beruf = null
}

function onChange(option) {
  store.beruf = option
  emits('complete')
}

const textStore = useTextStore()
const select = ref(null)

let lang = textStore.language
textStore.$subscribe((mutation, state) => {
  if (state.language != lang) {
    nextTick(() => {
      select.value.updateItems(true).then(() => {
        select.value.clear()
        nextTick(() => {
          select.value.load(store.beruf)
        })
      })
    })
  }
  lang = state.language
})
watch(
  () => store.beruf,
  (newValue) => {
    if (newValue) {
      nextTick(() => {
        select.value.updateItems(true).then(() => {
          select.value.clear()
          nextTick(() => {
            select.value.load(store.beruf)
          })
        })
      })
    }
  }
)
</script>
<template>
  <SelectElement
    ref="select"
    :delay="100"
    :filter-results="false"
    :label="t('beruf')"
    :default="store.beruf"
    :placeholder="t('beruf-frage')"
    :native="false"
    rules="required"
    name="beruf"
    :search="true"
    autocomplete="off"
    :items="searchBeruf"
    @select="onChange"
    @clear="onClear"
  >
  </SelectElement>
</template>
